import React, { useState, useEffect } from 'react'

import { getLenderOptions } from 'api/lender'
import { DisclosureModal } from 'components/DisclosureModal'
import { ConsentLabel } from 'components/FormikFields/FormikCheckbox/FormikCheckbox.styled'
import DisclosureType from 'state/enums/DisclosureType'
import LenderName from 'state/enums/LenderName'

export default function ConsentCheckboxLabel(props: {
    disclosureType: DisclosureType
}): JSX.Element {
    const { disclosureType } = props
    const [showDisclosureModal, setShowDisclosureModal] = useState(false)
    const [roadrunnerLenderId, setRoadrunnerLenderId] = useState<number>(0)

    useEffect(() => {
        const loadLendersOptions = async () => {
            const result = await getLenderOptions()

            result.data.objects.forEach((lender) => {
                if (lender.name === LenderName.ROADRUNNER_FINANCIAL) {
                    setRoadrunnerLenderId(lender.id)
                }
            })
        }

        loadLendersOptions().catch(() => setRoadrunnerLenderId(0))
    }, [])

    return (
        <ConsentLabel>
            <DisclosureModal
                showModal={showDisclosureModal}
                toggleModal={setShowDisclosureModal}
                modalTitle="General Application Disclosures"
                disclosureName={disclosureType}
                lenderId={roadrunnerLenderId}
            />
            <div
                style={{
                    display: 'block',
                    paddingLeft: '1vw',
                }}
            >
                {/* eslint-disable-next-line max-len */}
                By checking this box you have read and agreed to the following:{' '}
                <button
                    type="button"
                    onClick={() => setShowDisclosureModal(true)}
                >
                    General Application Disclosures
                </button>
                .
            </div>
        </ConsentLabel>
    )
}
